import { DpaIdCollabGraphqlUseFolders } from "@dpa-connect/dpa-id-collab";

export default function useSortedFolders() {
  const { data: sortedFolders } = DpaIdCollabGraphqlUseFolders(false);

  return { sortedFolders };
}
